import $ from "jquery";

const accoardionWithImageChenge = () => {
  const init = () => {
    foldAccordion();
  };

  const foldAccordion = () => {
    const el = {
      list: ".js-Awi__List",
    };

    if ($(el.list).length === 0) return;

    $(`${el.list}:not(:first-child) .mi-Awi__List__Description`).hide();
    $(`${el.list}:first-child`).addClass("isOpen");

    $(document).on("click", el.list, function () {
      const imgUrl = $(this).data("image");
      const selector = $(this).data("toselector");

      $(selector).attr("src", imgUrl);
      $(`${el.list} .mi-Awi__List__Description`).hide(300);
      $(this).find(".mi-Awi__List__Description").show(300);
      $(el.list).removeClass("isOpen");
      $(this).addClass("isOpen");
    });
  };

  init();
};

try {
  accoardionWithImageChenge();
} catch (error) {
  console.error(error);
}
